import {
	injuryAnklePainAchillesTendonSchema, injuryAnklePainFunctionalInstabilitySchema,
	injuryAnklePainSchema, injuryAnklePainSprainedAnkleSchema, injuryAnteriorCruciateLigamentRuptureSchema,
	injuryBackPainSchema,
	injuryBeaksPainSchema,
	injuryElbowPainSchema,
	injuryGroinPainAdductorSchema,
	injuryGroinPainIliopsoasSchema,
	injuryGroinPainInguinalSchema,
	injuryGroinPainPelvicFloorSchema,
	injuryGroinPainPubisSchema,
	injuryGroinPainSchema,
	injuryHeadAcheSchema,
	injuryHeelPainSchema,
	injuryHielspoorSchema, injuryHipImpingementSchema,
	injuryHipPainOsteoarthritisSchema,
	injuryHipPainSchema,
	injuryKneePainJumpersKneeSchema,
	injuryKneePainMeniscusInjurySchema,
	injuryKneePainOsteoarthritisSchema,
	injuryKneePainRunnersKneeSchema,
	injuryKneePainSchema, injuryLabrumDefectSchema,
	injuryLowerLegPainSchema,
	injuryNeckPainSchema,
	injuryPregnancySchema,
	injuryShoulderPainSchema,
	injuryTotalHipProsthesisSchema,
	injuryTotalKneeProsthesisSchema,
	injuryTrochanterMajorPainSyndromeSchema,
	injuryUpperLegPainSchema,
	injuryWristPainSchema,
	physicalTherapyDryNeedlingSchema,
	physicalTherapyGeneralSchema, physicalTherapyGladSchema,
	physicalTherapyMedicalTapingSchema,
	physicalTherapyMobilisingSchema, physicalTherapyPregnancySchema,
	physicalTherapyShockwaveTherapySchema,
} from '#fysio/helpers/schemaHelpers';

import HeelPainIllustration from '#fysio/app/assets/svg/illustrations/hielklachten.svg?url';
import KneePainIllustration from '#fysio/app/assets/svg/illustrations/knieklachten.svg?url';
import NeckPainIllustration from '#fysio/app/assets/svg/illustrations/nekklachten.svg?url';
import BackPainIllustration from '#fysio/app/assets/svg/illustrations/rugklachten.svg?url';
import AnklePainIllustration from '#fysio/app/assets/svg/illustrations/enkelklachten.svg?url';
import ShoulderPainIllustration from '#fysio/app/assets/svg/illustrations/schouderklachten.svg?url';
import HipPainIllustration from '#fysio/app/assets/svg/illustrations/heupklachten.svg?url';
import GroinPainIllustration from '#fysio/app/assets/svg/illustrations/liesklachten.svg?url';
import UpperLegPainIllustration from '#fysio/app/assets/svg/illustrations/bovenbeenklachten.svg?url';
import LowerLegPainIllustration from '#fysio/app/assets/svg/illustrations/onderbeenklachten.svg?url';
import ElbowPainIllustration from '#fysio/app/assets/svg/illustrations/elleboogklachten.svg?url';
import WristPainIllustration from '#fysio/app/assets/svg/illustrations/polsklachten.svg?url';
import BeaksPainIllustration from '#fysio/app/assets/svg/illustrations/bekkenklachten.svg?url';
import HeadAcheIllustration from '#fysio/app/assets/svg/illustrations/hoofdpijn.svg?url';
import PregnancyInjuryIllustration from '#fysio/app/assets/svg/illustrations/zwangerschapsklachten.svg?url';

import HeelPainIconLight from '#fysio/app/assets/svg/illustrations/icons/hielklachten-icon-light.svg?url';
import HeelPainIconDark from '#fysio/app/assets/svg/illustrations/icons/hielklachten-icon-dark.svg?url';
import KneePainIconLight from '#fysio/app/assets/svg/illustrations/icons/knieklachten-icon-light.svg?url';
import KneePainIconDark from '#fysio/app/assets/svg/illustrations/icons/knieklachten-icon-dark.svg?url';
import NeckPainIconLight from '#fysio/app/assets/svg/illustrations/icons/nekklachten-icon-light.svg?url';
import NeckPainIconDark from '#fysio/app/assets/svg/illustrations/icons/nekklachten-icon-dark.svg?url';
import BackPainIconLight from '#fysio/app/assets/svg/illustrations/icons/rugklachten-icon-light.svg?url';
import BackPainIconDark from '#fysio/app/assets/svg/illustrations/icons/rugklachten-icon-dark.svg?url';
import AnklePainIconLight from '#fysio/app/assets/svg/illustrations/icons/enkelklachten-icon-light.svg?url';
import AnklePainIconDark from '#fysio/app/assets/svg/illustrations/icons/enkelklachten-icon-dark.svg?url';
import ShoulderPainIconLight from '#fysio/app/assets/svg/illustrations/icons/schouderklachten-icon-light.svg?url';
import ShoulderPainIconDark from '#fysio/app/assets/svg/illustrations/icons/schouderklachten-icon-dark.svg?url';
import HipPainIconLight from '#fysio/app/assets/svg/illustrations/icons/heupklachten-icon-light.svg?url';
import HipPainIconDark from '#fysio/app/assets/svg/illustrations/icons/heupklachten-icon-dark.svg?url';
import GroinPainIconLight from '#fysio/app/assets/svg/illustrations/icons/liesklachten-icon-light.svg?url';
import GroinPainIconDark from '#fysio/app/assets/svg/illustrations/icons/liesklachten-icon-dark.svg?url';
import UpperLegPainIconLight from '#fysio/app/assets/svg/illustrations/icons/bovenbeenklachten-icon-light.svg?url';
import UpperLegPainIconDark from '#fysio/app/assets/svg/illustrations/icons/bovenbeenklachten-icon-dark.svg?url';
import LowerLegPainIconLight from '#fysio/app/assets/svg/illustrations/icons/onderbeenklachten-icon-light.svg?url';
import LowerLegPainIconDark from '#fysio/app/assets/svg/illustrations/icons/onderbeenklachten-icon-dark.svg?url';
import ElbowPainIconLight from '#fysio/app/assets/svg/illustrations/icons/elleboogklachten-icon-light.svg?url';
import ElbowPainIconDark from '#fysio/app/assets/svg/illustrations/icons/elleboogklachten-icon-dark.svg?url';
import WristPainIconLight from '#fysio/app/assets/svg/illustrations/icons/polsklachten-icon-light.svg?url';
import WristPainIconDark from '#fysio/app/assets/svg/illustrations/icons/polsklachten-icon-dark.svg?url';
import BeaksPainIconLight from '#fysio/app/assets/svg/illustrations/icons/bekkenklachten-icon-light.svg?url';
import BeaksPainIconDark from '#fysio/app/assets/svg/illustrations/icons/bekkenklachten-icon-dark.svg?url';
import HeadAcheIconLight from '#fysio/app/assets/svg/illustrations/icons/hoofdpijn-icon-light.svg?url';
import HeadAcheIconDark from '#fysio/app/assets/svg/illustrations/icons/hoofdpijn-icon-dark.svg?url';
import PregnancyInjuryIconLight from '#fysio/app/assets/svg/illustrations/icons/zwangerschapsklachten-icon-light.svg?url';
import PregnancyInjuryIconDark from '#fysio/app/assets/svg/illustrations/icons/zwangerschapsklachten-icon-dark.svg?url';
import type { UrlType } from '#base/core/types/UrlType';

export enum InjuryEnum {
	Hielspoor = 'hielspoor',
	KneePain = 'knee_pain',
	KneePainMeniscusInjury = 'knee_pain_meniscus_injury',
	KneePainRunnersKnee = 'knee_pain_runners_knee',
	KneePainJumpersKnee = 'knee_pain_jumpers_knee',
	KneePainOsteoarthritis = 'knee_pain_osteoarthritis',
	AnteriorCruciateLigamentRupture = 'anterior_cruciate_ligament_rupture',
	TotalKneeProsthesis = 'total_knee_prosthesis',
	NeckPain = 'neck_pain',
	BackPain = 'back_pain',
	AnklePain = 'ankle_pain',
	AnklePainAchillesTendon = 'ankle_pain_achilles_tendon',
	AnklePainFunctionalInstability = 'ankle_pain_functional_instability',
	AnklePainSprainedAnkle = 'ankle_pain_sprained_ankle',
	ShoulderPain = 'shoulder_pain',
	HipPain = 'hip_pain',
	HipPainOsteoarthritis = 'hip_pain_osteoarthritis',
	TotalHipProsthesis = 'total_hip_prosthesis',
	HipImpingement = 'hip_impingement',
	LabrumDefect = 'labrum_defect',
	TrochanterMajorPainSyndrome = 'trochanter_major_pain_syndrome',
	GroinPain = 'groin_pain',
	GroinPainAdductor = 'groin_pain_adductor',
	GroinPainIliopsoas = 'groin_pain_iliopsoas',
	GroinPainInguinal = 'groin_pain_inguinal',
	GroinPainPubis = 'groin_pain_pubis',
	GroinPainPelvicFloor = 'groin_pain_pelvic_floor',
	UpperLegPain = 'upper_leg_pain',
	LowerLegPain = 'lower_leg_pain',
	ElbowPain = 'elbow_pain',
	WristPain = 'wrist_pain',
	HeelPain = 'heel_pain',
	BeaksPain = 'beaks_pain',
	HeadAche = 'head_ache',
	PregnancyInjury = 'pregnancy_injury',
}

export class Injury {
	private readonly injury: InjuryEnum;

	private constructor(injury: InjuryEnum) {
		this.injury = injury;
	}

	public static init(injury: InjuryEnum): Injury {
		if (!Object.values(InjuryEnum).includes(injury)) {
			throw new Error(`Injury ${injury} is not supported.`);
		}

		return new this(injury);
	}

	public get title() {
		switch (this.injury) {
			case InjuryEnum.Hielspoor: return 'Hielspoor';
			case InjuryEnum.KneePain: return 'Knieklachten';
			case InjuryEnum.KneePainMeniscusInjury: return 'Meniscusblessure';
			case InjuryEnum.KneePainRunnersKnee: return 'Runners knee';
			case InjuryEnum.KneePainJumpersKnee: return 'Jumpers knee';
			case InjuryEnum.AnteriorCruciateLigamentRupture: return 'Voorste kruisbandruptuur';
			case InjuryEnum.TotalKneeProsthesis: return 'Totale knieprothese';
			case InjuryEnum.KneePainOsteoarthritis: return 'Knieartrose';
			case InjuryEnum.NeckPain: return 'Nekklachten';
			case InjuryEnum.BackPain: return 'Rugklachten';
			case InjuryEnum.AnklePain: return 'Enkelklachten';
			case InjuryEnum.AnklePainAchillesTendon: return 'Achillespeesblessures';
			case InjuryEnum.AnklePainFunctionalInstability: return 'Functionele enkelinstabiliteit';
			case InjuryEnum.AnklePainSprainedAnkle: return 'Verzwikte enkel';
			case InjuryEnum.ShoulderPain: return 'Schouderklachten';
			case InjuryEnum.HipPain: return 'Heupklachten';
			case InjuryEnum.HipPainOsteoarthritis: return 'Heupartrose';
			case InjuryEnum.TotalHipProsthesis: return 'Totale heupprothese';
			case InjuryEnum.HipImpingement: return 'Hip impingement / heupinklemming';
			case InjuryEnum.LabrumDefect: return 'Labrum defect';
			case InjuryEnum.TrochanterMajorPainSyndrome: return 'Trochanter Major pijnsyndroom';
			case InjuryEnum.GroinPain: return 'Liesklachten';
			case InjuryEnum.GroinPainAdductor: return 'Adductor gerelateerde liesklachten';
			case InjuryEnum.GroinPainIliopsoas: return 'Iliopsoas gerelateerde liesklachten';
			case InjuryEnum.GroinPainInguinal: return 'Inguinale gerelateerde liesklachten';
			case InjuryEnum.GroinPainPubis: return 'Pubis gerelateerde liesklachten';
			case InjuryEnum.GroinPainPelvicFloor: return 'Bekkenbodem gerelateerde liesklachten';
			case InjuryEnum.UpperLegPain: return 'Bovenbeenklachten';
			case InjuryEnum.LowerLegPain: return 'Onderbeenklachten';
			case InjuryEnum.ElbowPain: return 'Elleboogklachten';
			case InjuryEnum.WristPain: return 'Polsklachten';
			case InjuryEnum.HeelPain: return 'Hielklachten';
			case InjuryEnum.BeaksPain: return 'Bekkenklachten';
			case InjuryEnum.HeadAche: return 'Hoofdpijn';
			case InjuryEnum.PregnancyInjury: return 'Zwangerschapsklachten';
		}
	}

	public get schema() {
		switch (this.injury) {
			case InjuryEnum.Hielspoor: return injuryHielspoorSchema;
			case InjuryEnum.KneePain: return injuryKneePainSchema;
			case InjuryEnum.KneePainMeniscusInjury: return injuryKneePainMeniscusInjurySchema;
			case InjuryEnum.KneePainRunnersKnee: return injuryKneePainRunnersKneeSchema;
			case InjuryEnum.KneePainJumpersKnee: return injuryKneePainJumpersKneeSchema;
			case InjuryEnum.KneePainOsteoarthritis: return injuryKneePainOsteoarthritisSchema;
			case InjuryEnum.AnteriorCruciateLigamentRupture: return injuryAnteriorCruciateLigamentRuptureSchema;
			case InjuryEnum.TotalKneeProsthesis: return injuryTotalKneeProsthesisSchema;
			case InjuryEnum.NeckPain: return injuryNeckPainSchema;
			case InjuryEnum.BackPain: return injuryBackPainSchema;
			case InjuryEnum.AnklePain: return injuryAnklePainSchema;
			case InjuryEnum.AnklePainAchillesTendon: return injuryAnklePainAchillesTendonSchema;
			case InjuryEnum.AnklePainFunctionalInstability: return injuryAnklePainFunctionalInstabilitySchema;
			case InjuryEnum.AnklePainSprainedAnkle: return injuryAnklePainSprainedAnkleSchema;
			case InjuryEnum.ShoulderPain: return injuryShoulderPainSchema;
			case InjuryEnum.HipPain: return injuryHipPainSchema;
			case InjuryEnum.HipPainOsteoarthritis: return injuryHipPainOsteoarthritisSchema;
			case InjuryEnum.TotalHipProsthesis: return injuryTotalHipProsthesisSchema;
			case InjuryEnum.HipImpingement: return injuryHipImpingementSchema;
			case InjuryEnum.LabrumDefect: return injuryLabrumDefectSchema;
			case InjuryEnum.TrochanterMajorPainSyndrome: return injuryTrochanterMajorPainSyndromeSchema;
			case InjuryEnum.GroinPain: return injuryGroinPainSchema;
			case InjuryEnum.GroinPainAdductor: return injuryGroinPainAdductorSchema;
			case InjuryEnum.GroinPainIliopsoas: return injuryGroinPainIliopsoasSchema;
			case InjuryEnum.GroinPainInguinal: return injuryGroinPainInguinalSchema;
			case InjuryEnum.GroinPainPubis: return injuryGroinPainPubisSchema;
			case InjuryEnum.GroinPainPelvicFloor: return injuryGroinPainPelvicFloorSchema;
			case InjuryEnum.UpperLegPain: return injuryUpperLegPainSchema;
			case InjuryEnum.LowerLegPain: return injuryLowerLegPainSchema;
			case InjuryEnum.ElbowPain: return injuryElbowPainSchema;
			case InjuryEnum.WristPain: return injuryWristPainSchema;
			case InjuryEnum.HeelPain: return injuryHeelPainSchema;
			case InjuryEnum.BeaksPain: return injuryBeaksPainSchema;
			case InjuryEnum.HeadAche: return injuryHeadAcheSchema;
			case InjuryEnum.PregnancyInjury: return injuryPregnancySchema;
		}
	}

	public get treatments() {
		switch (this.injury) {
			case InjuryEnum.Hielspoor: return [
				physicalTherapyMedicalTapingSchema().innerHTML,
				physicalTherapyShockwaveTherapySchema().innerHTML,
				physicalTherapyGeneralSchema(
					'Oefeningen',
					'Versterken van de spieren rondom de hiel om kracht, stabiliteit en mobiliteit te verbeteren.',
				).innerHTML,
			];
			case InjuryEnum.KneePainMeniscusInjury:
			case InjuryEnum.KneePainRunnersKnee:
			case InjuryEnum.KneePainJumpersKnee:
			case InjuryEnum.AnteriorCruciateLigamentRupture:
			case InjuryEnum.TotalKneeProsthesis:
			case InjuryEnum.KneePain: return [
				physicalTherapyMedicalTapingSchema().innerHTML,
				physicalTherapyDryNeedlingSchema().innerHTML,
				physicalTherapyShockwaveTherapySchema().innerHTML,
				physicalTherapyMobilisingSchema().innerHTML,
				physicalTherapyGeneralSchema(
					'Knieoefeningen',
					'Versterken van de spieren rondom de knie om kracht, stabiliteit en mobiliteit te verbeteren.',
				).innerHTML,
			];
			case InjuryEnum.KneePainOsteoarthritis: return [
				physicalTherapyGladSchema().innerHTML,
			];
			case InjuryEnum.NeckPain: return [
				physicalTherapyDryNeedlingSchema().innerHTML,
				physicalTherapyMobilisingSchema().innerHTML,
				physicalTherapyGeneralSchema(
					'Nekoefeningen',
					'Versterken van de spieren rondom de nek om kracht, stabiliteit en mobiliteit te verbeteren.',
				).innerHTML,
			];
			case InjuryEnum.BackPain: return [
				physicalTherapyDryNeedlingSchema().innerHTML,
				physicalTherapyMobilisingSchema().innerHTML,
				physicalTherapyGeneralSchema(
					'Rugoefeningen',
					'Versterken van de rugspieren om kracht, stabiliteit en mobiliteit te verbeteren.',
				).innerHTML,
			];
			case InjuryEnum.AnklePain: return [
				physicalTherapyMedicalTapingSchema().innerHTML,
				physicalTherapyDryNeedlingSchema().innerHTML,
				physicalTherapyMobilisingSchema().innerHTML,
				physicalTherapyGeneralSchema(
					'Enkeloefeningen',
					'Versterken van de spieren rondom de enkel om kracht, stabiliteit en mobiliteit te verbeteren.',
				).innerHTML,
			];
			case InjuryEnum.ShoulderPain: return [
				physicalTherapyMedicalTapingSchema().innerHTML,
				physicalTherapyDryNeedlingSchema().innerHTML,
				physicalTherapyMobilisingSchema().innerHTML,
				physicalTherapyGeneralSchema(
					'Schouderoefeningen',
					'Versterken van de spieren rondom de schouder om kracht, stabiliteit en mobiliteit te verbeteren.',
				).innerHTML,
			];
			case InjuryEnum.HipPain: return [
				physicalTherapyDryNeedlingSchema().innerHTML,
				physicalTherapyMobilisingSchema().innerHTML,
			];
			case InjuryEnum.HipPainOsteoarthritis: return [
				physicalTherapyGladSchema().innerHTML,
			];
			case InjuryEnum.PregnancyInjury: return [
				physicalTherapyPregnancySchema().innerHTML,
			];

			// case InjuryEnum.TotalHipProsthesis: return []; // TODO: Possible Treatments
			// case InjuryEnum.HipImpingement: return []; // TODO: Possible Treatments
			// case InjuryEnum.LabrumDefect: return []; // TODO: Possible Treatments
			// case InjuryEnum.TrochanterMajorPainSyndrome: return []; // TODO: Possible Treatments
			// case InjuryEnum.GroinPain: return []; // TODO: Possible Treatments
			// case InjuryEnum.GroinPainAdductor: return []; // TODO: Possible Treatments
			// case InjuryEnum.GroinPainIliopsoas: return []; // TODO: Possible Treatments
			// case InjuryEnum.GroinPainInguinal: return []; // TODO: Possible Treatments
			// case InjuryEnum.GroinPainPubis: return []; // TODO: Possible Treatments
			// case InjuryEnum.GroinPainPelvicFloor: return []; // TODO: Possible Treatments
			// case InjuryEnum.UpperLegPain: return []; // TODO: Possible Treatments
			// case InjuryEnum.LowerLegPain: return []; // TODO: Possible Treatments
			// case InjuryEnum.ElbowPain: return []; // TODO: Possible Treatments
			// case InjuryEnum.WristPain: return []; // TODO: Possible Treatments
			// case InjuryEnum.HeelPain: return []; // TODO: Possible Treatments
			// case InjuryEnum.BeaksPain: return []; // TODO: Possible Treatments
			// case InjuryEnum.HeadAche: return []; // TODO: Possible Treatments
			default: return [
				physicalTherapyGeneralSchema(
					'Oefeningen',
					'Versterken van de spieren om kracht, stabiliteit en mobiliteit te verbeteren.',
				).innerHTML,
			];
		}
	}

	public get illustration() {
		switch (this.injury) {
			case InjuryEnum.Hielspoor:
			case InjuryEnum.HeelPain: return HeelPainIllustration;
			case InjuryEnum.KneePainMeniscusInjury:
			case InjuryEnum.KneePainRunnersKnee:
			case InjuryEnum.KneePainJumpersKnee:
			case InjuryEnum.AnteriorCruciateLigamentRupture:
			case InjuryEnum.TotalKneeProsthesis:
			case InjuryEnum.KneePainOsteoarthritis:
			case InjuryEnum.KneePain: return KneePainIllustration;
			case InjuryEnum.TotalHipProsthesis:
			case InjuryEnum.HipImpingement:
			case InjuryEnum.LabrumDefect:
			case InjuryEnum.TrochanterMajorPainSyndrome:
			case InjuryEnum.HipPainOsteoarthritis:
			case InjuryEnum.HipPain: return HipPainIllustration;
			case InjuryEnum.GroinPainAdductor:
			case InjuryEnum.GroinPainIliopsoas:
			case InjuryEnum.GroinPainInguinal:
			case InjuryEnum.GroinPainPubis:
			case InjuryEnum.GroinPainPelvicFloor:
			case InjuryEnum.GroinPain: return GroinPainIllustration;
			case InjuryEnum.UpperLegPain: return UpperLegPainIllustration;
			case InjuryEnum.LowerLegPain: return LowerLegPainIllustration;
			case InjuryEnum.ElbowPain: return ElbowPainIllustration;
			case InjuryEnum.WristPain: return WristPainIllustration;
			case InjuryEnum.BeaksPain: return BeaksPainIllustration;
			case InjuryEnum.HeadAche: return HeadAcheIllustration;
			case InjuryEnum.PregnancyInjury: return PregnancyInjuryIllustration;
			case InjuryEnum.NeckPain: return NeckPainIllustration;
			case InjuryEnum.BackPain: return BackPainIllustration;
			case InjuryEnum.AnklePainAchillesTendon:
			case InjuryEnum.AnklePainFunctionalInstability:
			case InjuryEnum.AnklePainSprainedAnkle:
			case InjuryEnum.AnklePain: return AnklePainIllustration;
			case InjuryEnum.ShoulderPain: return ShoulderPainIllustration;
		}
	}

	public get iconLight() {
		switch (this.injury) {
			case InjuryEnum.Hielspoor:
			case InjuryEnum.HeelPain: return HeelPainIconLight;
			case InjuryEnum.KneePainMeniscusInjury:
			case InjuryEnum.KneePainRunnersKnee:
			case InjuryEnum.KneePainJumpersKnee:
			case InjuryEnum.AnteriorCruciateLigamentRupture:
			case InjuryEnum.TotalKneeProsthesis:
			case InjuryEnum.KneePainOsteoarthritis:
			case InjuryEnum.KneePain: return KneePainIconLight;
			case InjuryEnum.TotalHipProsthesis:
			case InjuryEnum.HipImpingement:
			case InjuryEnum.LabrumDefect:
			case InjuryEnum.TrochanterMajorPainSyndrome:
			case InjuryEnum.HipPainOsteoarthritis:
			case InjuryEnum.HipPain: return HipPainIconLight;
			case InjuryEnum.GroinPainAdductor:
			case InjuryEnum.GroinPainIliopsoas:
			case InjuryEnum.GroinPainInguinal:
			case InjuryEnum.GroinPainPubis:
			case InjuryEnum.GroinPainPelvicFloor:
			case InjuryEnum.GroinPain: return GroinPainIconLight;
			case InjuryEnum.UpperLegPain: return UpperLegPainIconLight;
			case InjuryEnum.LowerLegPain: return LowerLegPainIconLight;
			case InjuryEnum.ElbowPain: return ElbowPainIconLight;
			case InjuryEnum.WristPain: return WristPainIconLight;
			case InjuryEnum.BeaksPain: return BeaksPainIconLight;
			case InjuryEnum.HeadAche: return HeadAcheIconLight;
			case InjuryEnum.PregnancyInjury: return PregnancyInjuryIconLight;
			case InjuryEnum.NeckPain: return NeckPainIconLight;
			case InjuryEnum.BackPain: return BackPainIconLight;
			case InjuryEnum.AnklePainAchillesTendon:
			case InjuryEnum.AnklePainFunctionalInstability:
			case InjuryEnum.AnklePainSprainedAnkle:
			case InjuryEnum.AnklePain: return AnklePainIconLight;
			case InjuryEnum.ShoulderPain: return ShoulderPainIconLight;
		}
	}

	public get iconDark() {
		switch (this.injury) {
			case InjuryEnum.Hielspoor:
			case InjuryEnum.HeelPain: return HeelPainIconDark;
			case InjuryEnum.KneePainMeniscusInjury:
			case InjuryEnum.KneePainRunnersKnee:
			case InjuryEnum.KneePainJumpersKnee:
			case InjuryEnum.AnteriorCruciateLigamentRupture:
			case InjuryEnum.TotalKneeProsthesis:
			case InjuryEnum.KneePainOsteoarthritis:
			case InjuryEnum.KneePain: return KneePainIconDark;
			case InjuryEnum.TotalHipProsthesis:
			case InjuryEnum.HipImpingement:
			case InjuryEnum.LabrumDefect:
			case InjuryEnum.TrochanterMajorPainSyndrome:
			case InjuryEnum.HipPainOsteoarthritis:
			case InjuryEnum.HipPain: return HipPainIconDark;
			case InjuryEnum.GroinPainAdductor:
			case InjuryEnum.GroinPainIliopsoas:
			case InjuryEnum.GroinPainInguinal:
			case InjuryEnum.GroinPainPubis:
			case InjuryEnum.GroinPainPelvicFloor:
			case InjuryEnum.GroinPain: return GroinPainIconDark;
			case InjuryEnum.UpperLegPain: return UpperLegPainIconDark;
			case InjuryEnum.LowerLegPain: return LowerLegPainIconDark;
			case InjuryEnum.ElbowPain: return ElbowPainIconDark;
			case InjuryEnum.WristPain: return WristPainIconDark;
			case InjuryEnum.BeaksPain: return BeaksPainIconDark;
			case InjuryEnum.HeadAche: return HeadAcheIconDark;
			case InjuryEnum.PregnancyInjury: return PregnancyInjuryIconDark;
			case InjuryEnum.NeckPain: return NeckPainIconDark;
			case InjuryEnum.BackPain: return BackPainIconDark;
			case InjuryEnum.AnklePainAchillesTendon:
			case InjuryEnum.AnklePainFunctionalInstability:
			case InjuryEnum.AnklePainSprainedAnkle:
			case InjuryEnum.AnklePain: return AnklePainIconDark;
			case InjuryEnum.ShoulderPain: return ShoulderPainIconDark;
		}
	}

	public get pageUrl(): UrlType | null {
		const title = `Meer over ${this.title}`;

		switch (this.injury) {
			case InjuryEnum.Hielspoor: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/hielpijn-hielklachten/hielspoor', title };
			case InjuryEnum.KneePain: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/kniepijn-knieklachten', title };
			case InjuryEnum.KneePainMeniscusInjury: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/kniepijn-knieklachten/meniscusblessure', title };
			case InjuryEnum.KneePainRunnersKnee: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/kniepijn-knieklachten/runners-knee', title };
			case InjuryEnum.KneePainJumpersKnee: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/kniepijn-knieklachten/jumpers-knee', title };
			case InjuryEnum.KneePainOsteoarthritis: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/kniepijn-knieklachten/knieartrose', title };
			case InjuryEnum.AnteriorCruciateLigamentRupture: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/kniepijn-knieklachten/voorste-kruisbandruptuur', title };
			case InjuryEnum.TotalKneeProsthesis: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/kniepijn-knieklachten/totale-knieprothese', title };
			case InjuryEnum.NeckPain: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/nekpijn-nekklachten', title };
			case InjuryEnum.BackPain: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/rugpijn-rugklachten', title };
			case InjuryEnum.ShoulderPain: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/schouderpijn-schouderklachten', title };
			case InjuryEnum.HipPain: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/heupklachten', title };
			case InjuryEnum.HipPainOsteoarthritis: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/heupklachten/heupartrose', title };
			case InjuryEnum.TotalHipProsthesis: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/heupklachten/totale-heupprothese', title };
			case InjuryEnum.HipImpingement: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/heupklachten/hip-impingement-heupinklemming', title };
			case InjuryEnum.LabrumDefect: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/heupklachten/labrum-defect', title };
			case InjuryEnum.TrochanterMajorPainSyndrome: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/heupklachten/trochanter-major-pijnsyndroom', title };
			case InjuryEnum.GroinPainAdductor: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/liesklachten/adductor-gerelateerde-liesklachten', title };
			case InjuryEnum.GroinPainIliopsoas: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/liesklachten/iliopsoas-gerelateerde-liesklachten', title };
			case InjuryEnum.GroinPainInguinal: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/liesklachten/inguinale-liesklachten', title };
			case InjuryEnum.GroinPainPubis: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/liesklachten/pubis-gerelateerde-liesklachten', title };
			case InjuryEnum.GroinPainPelvicFloor: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/liesklachten/bekkenbodem-gerelateerde-liesklachten', title };
			case InjuryEnum.GroinPain: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/liesklachten', title };
			case InjuryEnum.HeelPain: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/hielpijn-hielklachten', title };
			case InjuryEnum.PregnancyInjury: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/zwangerschapsklachten', title };
			case InjuryEnum.AnklePain: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/enkelklachten', title };
			case InjuryEnum.AnklePainAchillesTendon: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/enkelklachten/achillespeesblessure', title };
			case InjuryEnum.AnklePainFunctionalInstability: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/enkelklachten/functionele-enkelinstabiliteit', title };
			case InjuryEnum.AnklePainSprainedAnkle: return { url: '/fysiotherapie/pijnklachten-fysieke-beperkingen/enkelklachten/verzwikte-enkel', title };
			default: return null;
		}
	}
}
